import { Single as ProjectSingleOrder } from './Single';

export default ProjectSingleOrder;
